import { render, staticRenderFns } from "./trainStaff.vue?vue&type=template&id=9b2aa48c&scoped=true&"
import script from "./trainStaff.vue?vue&type=script&lang=js&"
export * from "./trainStaff.vue?vue&type=script&lang=js&"
import style0 from "./trainStaff.vue?vue&type=style&index=0&id=9b2aa48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2aa48c",
  null
  
)

export default component.exports